<template>
<div class="chapter">
<div class="inner_page">
<h1 title="Dedication"> </h1>
<p class="sectiontop" style="text-align: center;">To Anthony and Michael<br/>
  for battles won and battles lost—<br/>
  heroes through them all.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_dedication.vue?f6a0caac